import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {KitchenDisplayData} from "./kitchen-display.data";
import {
    MetaTagDefinitionData,
    MetaTagDefinitionReferenceData,
    MetaTagType
} from "../../catalogue/meta-tag/meta-tag.data";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class KitchenDisplayEntityModel extends EntityModel<KitchenDisplayData> {

    translateService: TranslateService;

    constructor(injector: Injector) {
        super(injector, KitchenDisplayData);
        this.translateService = injector.get(TranslateService, null);
    }

    private async addUntaggedTag(processor: KitchenDisplayData): Promise<void> {
        if (processor.matchNoTags) {
            const tag: MetaTagDefinitionReferenceData = EntityData.create(MetaTagDefinitionReferenceData);
            tag.metaTagDefinitionId = MetaTagDefinitionData.MATCH_UNTAGGED_ITEM;
            tag.name = await this.translateService.get("wbo.meta-tag.option.modifier.matchNoTags").toPromise();
            tag.type = MetaTagType.DOCKET_SELECTOR;
            processor.tags.unshift(tag);
            processor.matchNoTags = false;
        }
    }

    private removeUntaggedTag(processor: KitchenDisplayData): void {
        processor.matchNoTags = !!processor.tags.find((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId === MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
        processor.tags = processor.tags.filter((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId !== MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
    }

    protected override onBeforeSaveEntity(entityData: KitchenDisplayData) {
        this.removeUntaggedTag(this.data);
    }

    protected override onAfterLoadEntity(): void {
        this.addUntaggedTag(this.data);
    }
}
